module.exports = __webpack_public_path__ + "static/media/first_winner.dc64eae1.jpg";